/*!
 * Smart Search für Shopify (Debut Theme) – ohne App, ohne Hosting.
 * 1) Shopify Predictive Search API (schnell, serverseitig)
 * 2) Lokaler Fuzzy-Index mit Fuse.js (Tippfehler, Umlaute, SKU, Synonyme)
 *
 * Einbinden: Assets -> smart-search.js, in theme.liquid vor </body>:
 * <script src="{{ 'smart-search.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  /* ===================== Einstellungen ===================== */
  var CONFIG = {
    inputSelector: 'input[type="search"], input[name="q"]',
    minChars: 2,
    debounceMs: 180,
    maxResults: 8,
    cacheHours: 1,
    staleDays: 3, // ältere Daten sofort zeigen und im Hintergrund erneuern
    maxPages: 40, // 40 x 250 = 10.000 Produkte, danach Abbruch
    fuseUrl: 'https://cdn.jsdelivr.net/npm/fuse.js@7.0.0/dist/fuse.min.js',
    // Synonyme: Suchbegriff -> zusätzliche Begriffe (klein, ohne Umlaute)
    synonyms: {
      handy: ['smartphone', 'mobiltelefon'],
      smartphone: ['handy'],
      hose: ['jeans'],
      tshirt: ['t-shirt', 'shirt']
    },
    // Kategorieseiten bei Standard-Sortierung nach Marke/Modell gruppieren
    collectionSort: true,
    // Produkte pro Kategorieseite (0 = so viele wie Shopify pro Seite zeigt)
    collectionPageSize: 0,
    // Shopify-Produkttyp zum Gruppieren nutzen? (Bei dir steht dort teils das Kaliber -> aus)
    useProductType: false,
    // Erkennt Munition im Titel
    ammoPattern: /\s(\d+\s*stk|stk|fmj|jhp|jsp|hpbt|fmc|\d+\s*gr|\d+gr|grain|patronen|munition|hulsen|geschosse|schrot)\s/,
    texts: {
      noResults: 'Keine Treffer',
      all: 'Alle Ergebnisse anzeigen',
      count: 'Ergebnisse für',
      soldOut: 'Ausverkauft'
    }
  };

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CACHE_KEY = 'smartSearchIndex_v2_' + ROOT;
  var INDEX_KEY = 'smartSearchIndex_v3_' + ROOT;
  var fuse = null;
  var indexPromise = null;
  var box, activeInput, items = [], activeIdx = -1, timer, reqId = 0;

  /* ===================== Hilfsfunktionen ===================== */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s\-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: cur
      }).format(n);
    } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }

  function smallImg(src, size) {
    if (!src) return '';
    // Bild-URLs über die eigene Domain (/cdn/shop/…): Größe per ?width=
    if (src.indexOf('/cdn/shop/') !== -1) return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + (size || 120);
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + (size || 120) + 'x$1$3');
  }

  function expandQuery(q) {
    var words = norm(q).split(' ').filter(Boolean);
    var out = words.slice();
    words.forEach(function (w) {
      (CONFIG.synonyms[w] || []).forEach(function (s) { out.push(norm(s)); });
    });
    return out;
  }

  function loadScript(url) {
    return new Promise(function (res, rej) {
      if (window.Fuse) return res();
      var s = document.createElement('script');
      s.src = url; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  /* ===================== Index laden ===================== */
  // Schlanke Listen aus den Theme-Vorlagen collection.sslight / collection.ssindex
  // (nur die nötigen Felder statt der kompletten products.json, ca. 95 % weniger Daten).
  // Alle Seiten werden parallel geladen.
  function fetchSlim(handle, view) {
    var base = ROOT + 'collections/' + encodeURIComponent(handle) + '?view=' + view + '&page=';
    function get(n) {
      return fetch(base + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(view + ' ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    return get(1).then(function (first) {
      if (!first || !Array.isArray(first.products)) throw new Error(view + ' ungültig');
      var pages = Math.min(first.pages || 1, CONFIG.maxPages), rest = [];
      for (var n = 2; n <= pages; n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        return more.reduce(function (all, d) { return all.concat(d.products || []); }, first.products);
      });
    });
  }

  function slimToDoc(p) {
    return {
      h: p.h, t: p.t, v: p.v || '', av: !!p.av, img: p.img || '', price: p.price,
      title: norm(p.t), vendor: norm(p.v), type: norm(p.pt), tags: norm(p.tags),
      sku: norm(p.sku), body: norm(String(p.body || '').replace(/&[a-z0-9#]+;/gi, ' ')).slice(0, 400)
    };
  }

  // Liest einen Cache-Eintrag; "fresh" = jünger als cacheHours, sonst trotzdem
  // nutzbar (bis staleDays) – wird dann im Hintergrund erneuert.
  function readStore(key) {
    try {
      var o = JSON.parse(localStorage.getItem(key) || 'null');
      if (!o) return null;
      var age = Date.now() - o.time;
      if (age > CONFIG.staleDays * 86400000) return null;
      return { data: o.data, fresh: age < CONFIG.cacheHours * 3600000 };
    } catch (e) { return null; }
  }
  function writeStore(key, data) {
    try { localStorage.setItem(key, JSON.stringify({ time: Date.now(), data: data })); } catch (e) { /* egal */ }
  }

  function fetchAllProducts() {
    var all = [];
    function page(n) {
      return fetch(ROOT + 'products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('products.json ' + r.status); return r.json(); })
        .then(function (d) {
          var p = d.products || [];
          all = all.concat(p);
          if (p.length === 250 && n < CONFIG.maxPages) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }

  function toDoc(p) {
    var variants = p.variants || [];
    var skus = variants.map(function (v) { return v.sku; }).filter(Boolean).join(' ');
    var prices = variants.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : (p.tags || '');
    return {
      h: p.handle,
      t: p.title,
      v: p.vendor || '',
      av: variants.some(function (v) { return v.available; }),
      img: p.images && p.images[0] ? p.images[0].src : '',
      price: prices.length ? Math.min.apply(null, prices) : null,
      title: norm(p.title),
      vendor: norm(p.vendor),
      type: norm(p.product_type),
      tags: norm(tags),
      sku: norm(skus),
      body: norm((p.body_html || '').replace(/<[^>]*>/g, ' ')).slice(0, 400)
    };
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.time > CONFIG.cacheHours * 3600 * 1000) return null;
      return o.docs;
    } catch (e) { return null; }
  }

  function writeCache(docs) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), docs: docs }));
    } catch (e) { /* Speicher voll oder gesperrt: egal */ }
  }

  function buildFuse(docs) {
    fuse = new window.Fuse(docs, {
      includeScore: true,
      threshold: 0.35,
      ignoreLocation: true,
      minMatchCharLength: 2,
      keys: [
        { name: 'title', weight: 0.5 },
        { name: 'sku', weight: 0.2 },
        { name: 'tags', weight: 0.12 },
        { name: 'vendor', weight: 0.08 },
        { name: 'type', weight: 0.06 },
        { name: 'body', weight: 0.04 }
      ]
    });
  }

  function ensureIndex() {
    if (indexPromise) return indexPromise;
    function freshDocs() {
      return fetchSlim('all', 'ssindex').then(function (list) { return list.map(slimToDoc); })
        .catch(function () { return fetchAllProducts().then(function (products) { return products.map(toDoc); }); })
        .then(function (docs) { writeStore(INDEX_KEY, docs); return docs; });
    }
    indexPromise = loadScript(CONFIG.fuseUrl).then(function () {
      var cached = readStore(INDEX_KEY);
      if (cached) {
        buildFuse(cached.data);
        if (!cached.fresh) freshDocs().then(buildFuse).catch(function () {});
        return;
      }
      return freshDocs().then(buildFuse);
    }).catch(function (e) {
      console.warn('[smart-search] Lokaler Index nicht verfügbar:', e);
    });
    return indexPromise;
  }

  /* ===================== Suche ===================== */
  function localSearch(q, limit) {
    if (!fuse) return [];
    var terms = expandQuery(q);
    var seen = {}, out = [];
    // Gesamte Eingabe zuerst, dann einzelne Synonyme
    var queries = [norm(q)].concat(terms.slice(norm(q).split(' ').length));
    queries.forEach(function (term) {
      fuse.search(term, { limit: limit || CONFIG.maxResults }).forEach(function (r) {
        var d = r.item;
        if (!seen[d.h]) { seen[d.h] = true; out.push({ h: d.h, t: d.t, img: d.img, price: d.price, v: d.v, av: d.av, pt: d.type, score: r.score }); }
      });
    });
    out.sort(function (a, b) { return a.score - b.score; });
    return out;
  }

  function predictiveSearch(q) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + CONFIG.maxResults +
      '&resources[options][unavailable_products]=last';
    return fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        return list.map(function (p) {
          return { h: p.handle, t: p.title, img: p.image || (p.featured_image && p.featured_image.url) || '', price: p.price, v: p.vendor || '', av: p.available !== false, pt: norm(p.type), score: 0.5 };
        });
      })
      .catch(function () { return []; });
  }

  function merge(local, predictive, limit) {
    limit = limit || CONFIG.maxResults;
    var seen = {}, out = [];
    // Lokale Treffer (Fuzzy) und Shopify-Treffer abwechselnd bevorzugen
    var max = Math.max(local.length, predictive.length);
    for (var i = 0; i < max && out.length < limit; i++) {
      [predictive[i], local[i]].forEach(function (x) {
        if (x && !seen[x.h] && out.length < limit) { seen[x.h] = true; out.push(x); }
      });
    }
    return out;
  }

  // Wörter, die keine Modellfamilie sind
  // (Zustand, Werbung, Füllwörter – damit "neuwertige Glock" zu "Glock" gruppiert wird)
  var STOP = {};
  ('neu neue neuer neues new aktion sale angebot top kal und mit the ' +
   'fast wie sehr gut guter gute neuwertig neuwertige neuwertiger neuwertiges ' +
   'gebraucht gebrauchte gebrauchter gebrauchtes gepflegt gepflegte gepflegter ' +
   'custom limited edition sonderedition set paket bundle ' +
   'fabrikneu fabrikneue fabrikneuer fabrikneues fabriksneu fabriksneue fabriksneuer fabriksneues ' +
   'unbenutzt unbenutzte unbenutzter ungeschossen ungeschossene ungeschossener ' +
   'vorfuhrwaffe vorfuhrmodell demo kommission restposten abverkauf ' +
   'ausverkauft arms brandneu brandneue brandneuer seltene seltener selten im in kal').split(' ')
    .forEach(function (w) { STOP[w] = 1; });

  // Schreibweisen derselben Marke vereinheitlichen (bereits normalisiert: klein, ohne Umlaute)
  var BRAND_ALIASES = [
    [/\bheckler (und )?koch\b/g, 'hk'],
    [/\bh k\b/g, 'hk'],
    [/\bceska zbrojovka\b/g, 'cz'],
    [/\bsig sauer\b/g, 'sig'],
    [/\bsmith (und )?wesson\b/g, 'sw'],
    [/\bs w\b/g, 'sw'],
    [/\bsellier (und )?bellot\b/g, 'sb'],
    [/\bs b\b/g, 'sb'],
    [/\bhs[ -]?produkts?\b/g, 'hs'],
    [/\bgrand power\b/g, 'grandpower'],
    [/\bwather\b/g, 'walther'],
    [/\bdaniel defense\b/g, 'danieldefense']
  ];

  // Bekannte Marken: Die erste Marke im Titel bestimmt die Gruppe,
  // auch wenn davor z. B. "Oschatz", "fabriksneue" oder "Hunters Package" steht.
  // Neue Marken einfach klein und ohne Umlaute ergänzen.
  var BRANDS = {};
  ('glock cz grandpower magtech ruger rossi lovex hs steyr beretta vihtavuori hk ggg ppu ' +
   'springfield walther schmeisser sig haenel sabatti sw sb topshot taurus sierra tikka ' +
   'chiappa holosun rws wbp dsa hornady colt browning geco uberti savage canik iwi ' +
   'hammerli olight bergara geissele merkel zastava fortmeier howa cci keltec lancer ' +
   'federal aimpoint marlin sps mke a-tec benelli fiocchi kimber norinco danieldefense ' +
   'brenneke voere zoli astra vortex mauser sako blaser winchester remington').split(' ')
    .forEach(function (w) { BRANDS[w] = 1; });

  // Sortiert nach Produktart, darin nach Marke/Modellfamilie
  // (z. B. alle "CZ" untereinander), Gruppen in Relevanz-Reihenfolge.
  // Innerhalb einer Gruppe stehen exakte Treffer vor Fuzzy-Treffern.
  function arrange(list, q) {
    var qw = norm(q).split(' ').filter(Boolean);
    function words(p) {
      var t = norm(p.t);
      BRAND_ALIASES.forEach(function (a) { t = t.replace(a[0], a[1]); });
      return t.split(' ').filter(Boolean);
    }
    function isQueryWord(w) {
      return qw.some(function (x) { return w.indexOf(x) === 0 || x.indexOf(w) === 0; });
    }
    function exact(p) {
      var ws = words(p);
      return qw.every(function (x) { return ws.some(function (w) { return w.indexOf(x) === 0; }); });
    }
    // Gruppe: erste bekannte Marke im Titel (außer sie ist selbst der Suchbegriff),
    // sonst das erste aussagekräftige Wort (bei "grand power" z. B. "Stribog")
    function family(p) {
      var ws = words(p);
      for (var i = 0; i < ws.length; i++) {
        if (BRANDS[ws[i]] && !isQueryWord(ws[i])) return ws[i];
      }
      // Modell: erstes Wort NACH dem Suchbegriff ("Oschatz CZ 75" -> "75"), sonst davor
      var first = -1;
      for (var j = 0; j < ws.length; j++) { if (isQueryWord(ws[j])) { first = j; break; } }
      function ok(w) { return !isQueryWord(w) && !STOP[w] && !BRANDS[w] && w.length > 1; }
      var after = ws.slice(first + 1).filter(ok);
      var rest = after.length ? after : ws.filter(ok);
      return rest[0] || '';
    }
    // Produktart: Munition oder nicht (über den Titel erkannt).
    // Der Shopify-Produkttyp wird nur genutzt, wenn CONFIG.useProductType = true.
    function category(p) {
      if (CONFIG.useProductType && p.pt) return p.pt;
      var t = ' ' + norm(p.t) + ' ';
      return CONFIG.ammoPattern.test(t) ? '~munition' : '~waffen';
    }
    function groupBy(arr, keyFn) {
      var order = [], buckets = {};
      arr.forEach(function (p) {
        var k = keyFn(p);
        if (!buckets[k]) { buckets[k] = []; order.push(k); }
        buckets[k].push(p);
      });
      return order.map(function (k) { return buckets[k]; });
    }
    function flatten(groups) { return [].concat.apply([], groups); }
    function exactFirst(arr) {
      var a = [], b = [];
      arr.forEach(function (p) { (exact(p) ? a : b).push(p); });
      return a.concat(b);
    }
    // Modell innerhalb der Marke: erstes aussagekräftiges Wort nach der Gruppe
    // ("CZ Shadow 2 …" -> "shadow", "Oschatz CZ 75 …" -> "75")
    // k = 0: erstes Modellwort, k = 1: zweites (z. B. "GP" -> "R15"/"R308", "19" -> "X"/"Gen")
    function modelWord(p, k) {
      var ws = words(p), fam = family(p), i = ws.indexOf(fam);
      var after = ws.slice(i + 1).filter(function (w) {
        return !isQueryWord(w) && !STOP[w] && !BRANDS[w] && (w.length > 1 || /\d/.test(w));
      });
      return after[k] || '';
    }
    function m0(p) { return modelWord(p, 0); }
    function m1(p) { return modelWord(p, 1); }
    // Produktart -> Marke/Familie -> Modell -> Untermodell -> exakte vor Fuzzy-Treffern
    return flatten(groupBy(list, category).map(function (g) {
      return flatten(groupBy(g, family).map(function (fg) {
        return flatten(groupBy(fg, m0).map(function (mg) {
          return flatten(groupBy(mg, m1).map(exactFirst));
        }));
      }));
    }));
  }

  /* ===================== UI ===================== */
  function injectStyles() {
    var css =
      '.ss-box{position:absolute;z-index:99999;background:#fff;border:1px solid #ddd;border-radius:6px;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.15);max-height:70vh;overflow:auto;display:none;font-size:14px;text-align:left}' +
      '.ss-item{display:flex;align-items:center;gap:10px;padding:8px 12px;color:#222;text-decoration:none;border-bottom:1px solid #f0f0f0}' +
      '.ss-item:hover,.ss-item.ss-active{background:#f5f5f5}' +
      '.ss-item img{width:44px;height:44px;object-fit:cover;border-radius:4px;flex:none;background:#eee}' +
      '.ss-title{flex:1;line-height:1.3}.ss-price{white-space:nowrap;font-weight:600}' +
      '.ss-empty{padding:12px;color:#777}.ss-all{display:block;padding:10px 12px;text-align:center;font-weight:600;color:#222;text-decoration:none}' +
      '.ss-all:hover{background:#f5f5f5}mark.ss-hl{background:#fff2a8;color:inherit}' +
      '#ss-collection{margin-bottom:20px}.ss-card-cmp{color:#999;margin-right:4px}' +
      '#ss-results{margin-top:20px;margin-bottom:20px}.ss-page-info{margin:0 0 16px;color:#555}' +
      '.ss-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:40px 28px}' +
      '@media(max-width:600px){.ss-grid{grid-template-columns:repeat(2,1fr);gap:20px 12px}}' +
      '.ss-page-info{text-align:right;font-style:italic;margin:0 0 24px}' +
      '.ss-pager{display:flex;flex-wrap:wrap;justify-content:center;gap:6px;margin:28px 0 8px}' +
      '.ss-pg{min-width:38px;height:38px;padding:0 10px;border:1px solid #ccc;background:#fff;color:inherit;cursor:pointer;font:inherit}' +
      '.ss-pg:hover{border-color:#000}.ss-pg-active{background:#000;color:#fff;border-color:#000}' +
      '.ss-card{display:block;color:inherit;text-decoration:none}' +
      '.ss-card-img{display:block;aspect-ratio:4/3;background:#fff;overflow:hidden;margin-bottom:8px}' +
      '.ss-card-img img{width:100%;height:100%;object-fit:contain;display:block}' +
      '.ss-card-title{display:block;font-size:1.15em;line-height:1.4;margin-bottom:2px}' +
      '.ss-card-vendor{display:none}' +
      '.ss-card-price{display:block;color:#777}.ss-card:hover .ss-card-title{text-decoration:underline}';
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
  }

  function highlight(title, q) {
    var safe = esc(title);
    var words = String(q).split(/\s+/).filter(function (w) { return w.length > 1; });
    words.forEach(function (w) {
      var re = new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      safe = safe.replace(re, '<mark class="ss-hl">$1</mark>');
    });
    return safe;
  }

  function position() {
    if (!activeInput) return;
    var r = activeInput.getBoundingClientRect();
    var width = Math.max(r.width, 320);
    var left = Math.min(r.left + window.scrollX, window.scrollX + document.documentElement.clientWidth - width - 8);
    box.style.top = (r.bottom + window.scrollY + 4) + 'px';
    box.style.left = Math.max(left, 8) + 'px';
    box.style.width = width + 'px';
  }

  function render(results, q) {
    items = results;
    activeIdx = -1;
    var html = '';
    if (!results.length) {
      html = '<div class="ss-empty">' + esc(CONFIG.texts.noResults) + '</div>';
    } else {
      results.forEach(function (p) {
        var img = p.img ? '<img src="' + esc(smallImg(p.img)) + '" alt="" loading="lazy">' : '<img alt="">';
        var price = p.price != null && p.price !== '' ? (parseFloat(p.price) > 0 ? money(p.price) : 'Preis auf Anfrage') : '';
        html += '<a class="ss-item" href="' + esc(ROOT + 'products/' + p.h) + '">' + img +
          '<span class="ss-title">' + highlight(p.t, q) + '</span>' +
          '<span class="ss-price">' + esc(price) + '</span></a>';
      });
      html += '<a class="ss-all" href="' + esc(ROOT + 'search?q=' + encodeURIComponent(q)) + '">' + esc(CONFIG.texts.all) + '</a>';
    }
    box.innerHTML = html;
    position();
    box.style.display = 'block';
  }

  function hide() { if (box) box.style.display = 'none'; activeIdx = -1; }

  function setActive(i) {
    var els = box.querySelectorAll('.ss-item');
    if (!els.length) return;
    if (activeIdx >= 0 && els[activeIdx]) els[activeIdx].classList.remove('ss-active');
    activeIdx = (i + els.length) % els.length;
    els[activeIdx].classList.add('ss-active');
    els[activeIdx].scrollIntoView({ block: 'nearest' });
  }

  function run(q) {
    var id = ++reqId;
    Promise.all([ensureIndex().then(function () { return localSearch(q); }), predictiveSearch(q)])
      .then(function (res) {
        if (id !== reqId) return; // veraltete Antwort verwerfen
        render(arrange(merge(res[0], res[1]), q), q);
      });
  }

  function onInput(e) {
    activeInput = e.target;
    var q = activeInput.value.trim();
    clearTimeout(timer);
    if (q.length < CONFIG.minChars) { reqId++; hide(); return; }
    timer = setTimeout(function () { run(q); }, CONFIG.debounceMs);
  }

  function onKey(e) {
    if (!box || box.style.display === 'none') return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIdx + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIdx - 1); }
    else if (e.key === 'Escape') { hide(); }
    else if (e.key === 'Enter' && activeIdx >= 0) {
      var els = box.querySelectorAll('.ss-item');
      if (els[activeIdx]) { e.preventDefault(); window.location.href = els[activeIdx].href; }
    }
  }

  /* ===================== Suchergebnisseite ===================== */
  var PAGE_LIMIT = 60; // maximal berechnete Treffer
  var PAGE_SIZE = 9;   // pro Seite: 3 Spalten x 3 Reihen

  function isSearchPage() {
    return /\/search\/?$/.test(location.pathname) && new URLSearchParams(location.search).has('q');
  }

  // Blendet die Original-Ergebnisliste von Shopify aus
  function hideOriginals(main, target) {
    var hidden = [];
    var marked = ['ss-original', 'ss-original-noresults'].map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);
    var els = marked.length ? marked : Array.prototype.slice.call(
      main.querySelectorAll('.grid--uniform, .search-results, ul.list--no-bullets, .pagination'));
    els.forEach(function (el) {
      if (el.contains(target) || target.contains(el)) return;
      hidden.push({ el: el, display: el.style.display });
      el.style.display = 'none';
    });
    return hidden;
  }

  // opts (optional): { pageSize, info (HTML über dem Raster), onPage(page) }
  function drawPage(target, list, q, page, opts) {
    opts = opts || {};
    var size = opts.pageSize || PAGE_SIZE;
    page = Math.min(Math.max(page || 1, 1), Math.max(Math.ceil(list.length / size), 1));
    var pages = Math.ceil(list.length / size);
    var slice = list.slice((page - 1) * size, page * size);
    var info = opts.info != null ? opts.info :
      list.length + ' ' + esc(CONFIG.texts.count) + ' „' + esc(q) + '“';
    var html = (info ? '<p class="ss-page-info">' + info + '</p>' : '') + '<div class="ss-grid">';
    slice.forEach(function (p) {
      var img = p.img ? '<img src="' + esc(smallImg(p.img, 400)) + '" alt="' + esc(p.t) + '" loading="lazy">' : '';
      var price = p.price != null && p.price !== '' ? (parseFloat(p.price) > 0 ? money(p.price) : 'Preis auf Anfrage') : '';
      var cmp = p.cmp && parseFloat(p.cmp) > parseFloat(p.price) ? money(p.cmp) : '';
      html += '<a class="ss-card" href="' + esc(ROOT + 'products/' + p.h) + '">' +
        '<span class="ss-card-img">' + img + '</span>' +
        '<span class="ss-card-title">' + esc(p.t) + '</span>' +
        (p.v ? '<span class="ss-card-vendor">' + esc(p.v) + '</span>' : '') +
        '<span class="ss-card-price">' +
        (cmp ? '<s class="ss-card-cmp">' + esc(cmp) + '</s> ' : '') + esc(price) +
        (p.av === false ? ' · ' + esc(CONFIG.texts.soldOut) : '') + '</span></a>';
    });
    html += '</div>';
    if (pages > 1) {
      html += '<nav class="ss-pager">';
      for (var i = 1; i <= pages; i++) {
        html += '<button type="button" class="ss-pg' + (i === page ? ' ss-pg-active' : '') +
          '" data-p="' + i + '">' + i + '</button>';
      }
      html += '</nav>';
    }
    target.innerHTML = html;
    Array.prototype.forEach.call(target.querySelectorAll('.ss-pg'), function (b) {
      b.addEventListener('click', function () {
        var p = parseInt(b.getAttribute('data-p'), 10);
        drawPage(target, list, q, p, opts);
        if (opts.onPage) opts.onPage(p);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function renderSearchPage() {
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    var target = document.getElementById('ss-results');
    if (!target) {
      target = document.createElement('div');
      target.id = 'ss-results';
      (main.querySelector('.page-width') || main).appendChild(target);
    }
    var hidden = hideOriginals(main, target);
    function restore() {
      hidden.forEach(function (h) { h.el.style.display = h.display; });
      target.innerHTML = '';
    }
    target.innerHTML = '<p class="ss-page-info">…</p>';
    Promise.all([
      ensureIndex().then(function () { return localSearch(q, PAGE_LIMIT); }),
      predictiveSearch(q)
    ]).then(function (res) {
      var list = arrange(merge(res[0], res[1], PAGE_LIMIT), q);
      if (!list.length) return restore(); // nichts gefunden: Shopify-Original zeigen
      drawPage(target, list, q);
    }).catch(restore);
  }

  /* ===================== Kategorieseiten (Collections) ===================== */
  // Nur bei der Standard-Sortierung ("Ausgewählt"): ganze Kategorie laden,
  // nach Marke/Modell gruppieren und selbst mit Seitenzahlen anzeigen.
  // Andere Sortierungen (Preis, A-Z …) bleiben unverändert von Shopify.

  function collectionHandle() {
    // /collections/<handle> oder /collections/<handle>/ – aber nicht /collections/x/<tag> oder /products/
    var m = location.pathname.match(/\/collections\/([^\/]+)\/?$/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function isDefaultCollectionSort() {
    var params = new URLSearchParams(location.search);
    var sort = params.get('sort_by');
    var select = document.getElementById('SortBy');
    var def = (select && select.getAttribute('data-default-sortby')) || 'manual';
    if (sort && sort !== def) return false;
    // Filter (Tags oder Filter-Parameter) aktiv? Dann Shopify machen lassen
    var filtered = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'constraint') filtered = true; });
    return !filtered;
  }

  function fetchCollection(handle) {
    var all = [];
    function page(n) {
      return fetch(ROOT + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('collection ' + r.status); return r.json(); })
        .then(function (d) {
          var p = d.products || [];
          all = all.concat(p);
          if (p.length === 250 && n < CONFIG.maxPages) return page(n + 1);
          return all;
        });
    }
    return page(1);
  }

  function collectionItem(p) {
    var variants = p.variants || [];
    var prices = variants.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
    var cheapest = null;
    variants.forEach(function (v) {
      if (!cheapest || parseFloat(v.price) < parseFloat(cheapest.price)) cheapest = v;
    });
    return {
      h: p.handle,
      t: p.title,
      img: p.images && p.images[0] ? p.images[0].src : '',
      price: prices.length ? Math.min.apply(null, prices) : null,
      cmp: cheapest && cheapest.compare_at_price ? cheapest.compare_at_price : null,
      av: variants.some(function (v) { return v.available; }),
      pt: norm(p.product_type)
    };
  }

  function loadCollection(handle) {
    var key = 'smartSearchCol_v2_' + ROOT + handle;
    function fresh() {
      return fetchSlim(handle, 'sslight')
        .then(function (list) {
          return list.map(function (p) {
            return { h: p.h, t: p.t, img: p.img || '', price: p.price, cmp: p.cmp, av: !!p.av, pt: norm(p.pt) };
          });
        })
        .catch(function () { return fetchCollection(handle).then(function (products) { return products.map(collectionItem); }); })
        .then(function (items) { writeStore(key, items); return items; });
    }
    // Schon einmal geladen: sofort anzeigen, bei älteren Daten im Hintergrund erneuern
    var cached = readStore(key);
    if (cached) {
      if (!cached.fresh) fresh().catch(function () {});
      return Promise.resolve(cached.data);
    }
    return fresh();
  }

  function renderCollectionPage() {
    var handle = collectionHandle();
    var wrap = document.getElementById('Collection');
    if (!handle || !wrap || !isDefaultCollectionSort()) return;
    var grid = wrap.querySelector('.grid--view-items');
    if (!grid) return;

    // Gleich viele Produkte pro Seite wie Shopify (Anzahl auf der aktuellen Seite, mind. 9)
    var perPage = Math.max(grid.querySelectorAll('.grid__item').length, 9);
    if (CONFIG.collectionPageSize) perPage = CONFIG.collectionPageSize;

    var originals = Array.prototype.slice.call(wrap.querySelectorAll('.grid--view-items, .pagination'));
    var target = document.createElement('div');
    target.id = 'ss-collection';
    // Platz der Shopify-Produktliste freihalten, solange geladen wird –
    // sonst springt der Text darunter (SEO-Text, Footer) kurz nach oben.
    var keepHeight = originals.reduce(function (sum, el) { return sum + el.offsetHeight; }, 0);
    if (keepHeight) target.style.minHeight = keepHeight + 'px';
    wrap.insertBefore(target, wrap.firstChild);
    originals.forEach(function (el) { el.style.display = 'none'; });
    target.innerHTML = '<p class="ss-page-info">…</p>';

    function restore() {
      target.style.minHeight = '';
      originals.forEach(function (el) { el.style.display = ''; });
      if (target.parentNode) target.parentNode.removeChild(target);
    }

    var startPage = parseInt(new URLSearchParams(location.search).get('page'), 10) || 1;

    loadCollection(handle).then(function (items) {
      if (!items.length) return restore();
      var list = arrange(items, '');
      drawPage(target, list, '', startPage, {
        pageSize: perPage,
        info: '', // Anzahl zeigt Debut schon oben ("182 Produkte")
        onPage: function (p) {
          try {
            var u = new URL(location.href);
            if (p > 1) u.searchParams.set('page', p); else u.searchParams.delete('page');
            history.replaceState(null, '', u.toString());
          } catch (e) { /* egal */ }
        }
      });
      target.style.minHeight = '';
    }).catch(function (e) {
      console.warn('[smart-search] Kategorie-Sortierung nicht möglich:', e);
      restore();
    });
  }

  function init() {
    injectStyles();
    try { localStorage.removeItem(CACHE_KEY); } catch (e) { /* alter, großer Index */ }
    box = document.createElement('div');
    box.className = 'ss-box';
    box.setAttribute('role', 'listbox');
    document.body.appendChild(box);

    document.addEventListener('input', function (e) {
      if (e.target.matches && e.target.matches(CONFIG.inputSelector)) onInput(e);
    });
    document.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches(CONFIG.inputSelector)) {
        activeInput = e.target;
        ensureIndex(); // Index schon beim Fokus vorladen
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.target.matches && e.target.matches(CONFIG.inputSelector)) onKey(e);
    });
    document.addEventListener('click', function (e) {
      if (!box.contains(e.target) && !(e.target.matches && e.target.matches(CONFIG.inputSelector))) hide();
    });
    window.addEventListener('resize', position);

    if (isSearchPage()) renderSearchPage();
    else if (CONFIG.collectionSort) renderCollectionPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
